module.exports = __webpack_public_path__ + "img/12th_jobs-and-careers.714db6e8.webp";